import React from 'react';
import ClientLedger from '../admin/ClientLedger';

// Reuse the same component for the billing portal view
export default ClientLedger;


